<template>
  <form @submit.prevent="">
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <!-- Header -->
      <template #header>
        <div class="custom-header">
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">
                {{ title }}
              </h4>
              <span class="custom-subtitle"></span>
            </div>
            <div class="col-md-1">
              <a href="#" class="custom-close" @click="close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <!-- Body -->
      <template #body>
        <div class="row">
          <div class="col">
            <!-- Firm Name -->
            <div class="row">
              <div class="col-6">
                <z-input
                  v-model="locationName"
                  name="locationName"
                  label="Name"
                  :validator="v$"
                  @keyup="changed"
                  @change="changed"
                />
              </div>
              <div class="col-3">
                <z-input
                  v-model="locationNumber"
                  name="locationNumber"
                  label="Number"
                  @keyup="changed"
                  @change="changed"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <!-- First, Last Name -->
            <div class="row">
              <div class="col">
                <z-input v-model="firstname" name="firstname" label="First Name" :validator="v$" />
              </div>
              <div class="col">
                <z-input v-model="lastname" name="lastname" label="Last Name" :validator="v$" />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <!-- Address Lines -->
            <div class="row">
              <div class="col">
                <z-input
                  v-model="addressLines"
                  name="AddressLines"
                  label="Street Address"
                  :validator="v$"
                />
              </div>
            </div>
            <!-- City, State/Province, Postal Code -->
            <div class="row">
              <div class="col">
                <z-input v-model="city" name="City" label="City" :validator="v$" />
              </div>
              <div class="col-3">
                <z-select
                  v-model="stateProvince"
                  label="State"
                  name="stateProvince"
                  :options="lookups['StateProvince']"
                  :validator="v$"
                />
              </div>
              <div class="col-2">
                <z-input
                  v-model="postalCode"
                  name="PostalCode"
                  label="Postal Code"
                  :validator="v$"
                />
              </div>
              <div class="col-3">
                <z-select
                  v-model="country"
                  label="Country"
                  name="country"
                  :options="lookups['Country']"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- Email -->
          <div class="col-6">
            <z-input v-model="emailAddress" name="EmailAddress" label="Email" :validator="v$" />
          </div>
          <div class="col"></div>
        </div>
      </template>
      <!-- Footer -->
      <template #footer>
        <div class="custom-footer">
          <div class="col-1">
            <span title="location id">#{{ ids }}</span>
          </div>
          <div class="col">
            <z-message v-model="message" class="alert alert-warning mt-2" />
          </div>
          <div class="col custom-right-align">
            <button type="button" class="btn btn-light" :disabled="isSaving" @click="close()">
              Cancel
            </button>
            <button
              v-show="isSave"
              class="btn btn-danger ms-2"
              :disabled="isSaving"
              @click="save()"
            >
              <FontAwesomeIcon v-if="isSaving" icon="fa-solid fa-spinner" spin />
              <span :class="{ 'me-2': isSaving }">Save</span>
            </button>
          </div>
        </div>
      </template>
    </z-dialog>
  </form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { lookupStore } from '@/stores/lookup'
import { locationStore } from '@/stores/location'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
export default {
  name: 'DialogAddMember',
  components: {
    ZDialog,
    ZInput,
    ZSelect,
    FontAwesomeIcon
  },
  props: {
    modelValue: {
      type: Object
    }
  },
  data() {
    return {
      modalSize: 'modal-xl',
      isSave: false,
      message: null,
      rules: {
        locationName: { required },
        addressLines: { required },
        city: { required },
        stateProvince: { required },
        postalCode: { required },
        email: { required }
      },
      v$: null,
      isSaving: false
    }
  },
  mounted() {
    this.isSaving = false
  },
  emits: ['changed', 'closing', 'saved'],
  computed: {
    ...mapState(lookupStore, ['lookups']),
    ...mapState(locationStore, ['addMember']),
    isVisible() {
      let _is = false
      if (this.modelValue) {
        _is = true
        this.init()
      }
      return _is
    },
    title() {
      let _title = ''
      if (this.modelValue) {
        _title = 'Adding Location'
      }
      return _title
    },
    locationName: {
      get() {
        let _data = null
        if (this.addMember) {
          _data = this.addMember.locationName
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAddMember({
          name: 'locationName',
          value: value
        })
      }
    },
    locationNumber: {
      get() {
        let _data = null
        if (this.addMember) {
          _data = this.addMember.locationNumber
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAddMember({
          name: 'locationNumber',
          value: value
        })
      }
    },
    firstname: {
      get() {
        let _data = null
        if (this.addMember) {
          _data = this.addMember.firstname
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAddMember({
          name: 'firstname',
          value: value
        })
      }
    },
    lastname: {
      get() {
        let _data = null
        if (this.addMember) {
          _data = this.addMember.lastname
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAddMember({
          name: 'lastname',
          value: value
        })
      }
    },
    emailAddress: {
      get() {
        let _data = null
        if (this.addMember) {
          _data = this.addMember.email
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAddMember({
          name: 'email',
          value: value
        })
        this.setAddMember({
          name: 'username',
          value: value
        })
      }
    },
    addressLines: {
      get() {
        let _data = null
        if (this.addMember) {
          _data = this.addMember.addressLines
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAddMember({
          name: 'addressLines',
          value: value
        })
      }
    },
    city: {
      get() {
        let _data = null
        if (this.addMember) {
          _data = this.addMember.city
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAddMember({
          name: 'city',
          value: value
        })
      }
    },
    stateProvince: {
      get() {
        let _data = null
        if (this.addMember) {
          _data = this.addMember.stateProvince
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAddMember({
          name: 'stateProvince',
          value: value
        })
      }
    },
    postalCode: {
      get() {
        let _data = null
        if (this.addMember) {
          _data = this.addMember.postalCode
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAddMember({
          name: 'postalCode',
          value: value
        })
      }
    },
    country: {
      get() {
        let _data = null
        if (this.addMember) {
          _data = this.addMember.country
        }
        return _data
      },
      set(value) {
        this.isSave = true
        this.setAddMember({
          name: 'country',
          value: value
        })
      }
    }
  },
  methods: {
    ...mapActions(locationStore, ['setAddMember', 'saveNewMember']),
    init() {
      this.v$ = useVuelidate(this.rules, this.addMember)
    },
    close() {
      this.$emit('closing')
    },
    changed() {
      this.isSave = true
      this.$emit('changed')
    },
    async save() {
      // const valid = await this.v$.$validate()
      console.log('New Member', this.addMember)
      // if (valid) {
      let found = null
      if (this.addMember.stateProvince) {
        found = this.lookups['StateProvince'].find(
          (item) => parseInt(item.value) === parseInt(this.addMember.stateProvince)
        )
        if (found) {
          this.addMember.stateProvinceId = this.addMember.stateProvince
          this.addMember.stateProvince = found.name
        }
      }
      if (this.addMember.stateProvince) {
        found = this.lookups['Country'].find(
          (item) => parseInt(item.value) === parseInt(this.addMember.country)
        )
        if (found) {
          this.addMember.countryId = this.addMember.country
          this.addMember.country = found.name
        }
      }
      console.log('Saving New Member', this.addMember)
      await this.saveNewMember(this.addMember)
      this.$emit('saved')
      // }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.custom-subtitle {
  font-size: 0.9em;
}
</style>
